import { isAutonation } from 'site-modules/shared/utils/dealer-details-utils';

export function showChatButton({ isMobile, parentDealershipName, dealerSmsNumber, isEdmundsChatActive }) {
  return !isMobile && isAutonation(parentDealershipName) && !!dealerSmsNumber && isEdmundsChatActive;
}
